<template>
    <div class="relative">
        <div class="absolute bg-overlay-100 inset-0 ghost-center z-10" v-show="loading">
            <img src="./loader.gif" alt="loader"/>
        </div>
        <div class="rounded-t border py-1 bg-primary-600">
            <div class="overflow-auto">
                <table class="base-table w-full">
                    <tr class="bg-primary-600">
                        <slot name="header"></slot>
                    </tr>
                    <template v-for="(row, index) in filter">
                        <tr @click="rowClicked(row, index)" v-bind="bindings(row, index)">
                            <slot :row="row" :index="index"></slot>
                        </tr>
                        <slot name="extra" :row="row" :index="index"></slot>
                    </template>
                </table>
            </div>
            <div class="w-full p-3 bg-white" v-if="filter.length === 0">
                <div class="border border-dashed p-2">No results</div>
            </div>
            <div class="p-2 border-t bg-white">
                <m-paging :count="count" :page="page" :rowsPerPage="rows" @update="updatePaging"
                          :showRefresh="showRefresh" @refresh="refresh()"></m-paging>
            </div>
        </div>
    </div>
</template>
<script>
import Paging from './paging.vue'

export default {
    components: {
        'm-paging': Paging
    },
    name: 'm-basetable',
    props: {
        data: Array,
        rowBind: Function,
        loading: Boolean,
        count: Number,
        page: Number,
        rows: Number,
        showRefresh: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selected: -1
        }
    },
    methods: {
        bindings(row, index) {
            var bindings = this.rowBind ? this.rowBind(row, index, this.selected) : null
            return {
                'class': {
                    'alternate-row': index !== this.selected,
                    'bg-secondary-600 text-white': index === this.selected,
                    'row': index !== this.selected
                },
                ...bindings
            }
        },
        updatePaging(page, rowsPerPage) {
            this.page = page
            this.rows = rowsPerPage
            this.$emit('refresh', page, rowsPerPage)
        },
        refresh() {
            this.$emit('refresh', this.page, this.rows)
        },
        rowClicked(row, index) {
            this.selected = index
            this.$emit('click', row, index)
        }
    },
    computed: {
        filter() {
            if ((this.count || this.data.length) == 0) {
                return []
            }
            // return this.data.slice(this.page * this.rows,  (this.page * this.rows) + this.rows)
            return this.data
        }
    }
}
</script>

<style lang="scss" scoped>

.base-table {
    th {
        @apply text-white text-white font-normal text-left px-2;
    }

    td {
        @apply border-b border px-2;
    }

    tr {
        @apply cursor-pointer;
    }

    tr.row {
        &:hover {
            @apply bg-gray-400;
        }
    }
}

.alternate-row:nth-child(even) {
    @apply bg-gray-100
}

.alternate-row:nth-child(odd) {
    @apply bg-white;
}
</style>

